import React from 'react';
import { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import propTypes from './common/prop-types';
import Hero from './fund-components/hero';
import Main from './fund-components/main';

export default function Fund(props) {
  const common = commonProps();

  return (
    <ThemeProvider theme={common}>
      <Hero {...props} />
      <Main {...props} />
    </ThemeProvider>
  );
}

Fund.propTypes = propTypes;
